import { memo as Memo } from 'react';

//* Components
import CustomLottie from '../../CustomLottie';

//* JSONs
import ziggyAwardsJSON from './ziggyAwards.json';

//* Styles
import ZiggyAwardsStyle from './style';

const ZiggyAwards = Memo(() => {
	return (
		<ZiggyAwardsStyle className={'ziggyAwards'}>
			<CustomLottie
				isStopped={false}
				animData={ziggyAwardsJSON}
			/>
		</ZiggyAwardsStyle>
	);
});

export default ZiggyAwards;
